import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { MultilingualService } from '../core/services/multilingual/multilingual.service';
import { Subscription } from 'rxjs';

export interface TruncateTextConfigInterface {
  translationKey: string,
  DEFAULT_CHARS_LIMIT: number,
  DEFAULT_NOTE_WIDTH: string,
  mediaQueryCharsMapping: Record<string, {
    mediaQuery: MediaQueryList,
    chars: number,
    textWidth: string
  }>
}
@Directive({
  selector: '[appTruncateTextWithEllipses]'
})
export class TruncateTextWithEllipsesDirective implements OnInit, OnDestroy {

  private _config!: TruncateTextConfigInterface;
  private subscription: Subscription = new Subscription();

  @Input() set config(config: TruncateTextConfigInterface)
  {
    this._config = config;
    this.addMediaChangeListener();
    this.checkResolution();

    this.subscription.add(this.langService.langMapObservable.subscribe(() => {
      this.checkResolution();
    }));
  }

  constructor(private elementRef: ElementRef, private langService: MultilingualService) { }

  ngOnInit(): void { }

  private addMediaChangeListener() {
    // add eventListeners for media queries
    Object.entries(this._config.mediaQueryCharsMapping).forEach(([key, data]) => {
      data.mediaQuery.addEventListener('change', this.onMediaQueryChange.bind(this));
    });
  }

  private checkResolution(): void {
    let charsLimit!: number;
    let contentWidth!: string;

    // get the maximum chars limit and width for the matched resolution
    for (let itemKey of Object.keys(this._config.mediaQueryCharsMapping)) {
      if (this._config.mediaQueryCharsMapping[itemKey].mediaQuery.matches) {
        console.log('resolution', this._config.mediaQueryCharsMapping[itemKey].mediaQuery);
        charsLimit = this._config.mediaQueryCharsMapping[itemKey].chars;
        contentWidth = this._config.mediaQueryCharsMapping[itemKey].textWidth;
        break;
      }
    }

    // set default values, if the resolution is not in the list
    if (!contentWidth || !charsLimit) {
      charsLimit = this._config.DEFAULT_CHARS_LIMIT;
      contentWidth = this._config.DEFAULT_NOTE_WIDTH;
    }
    this.setContentWidth(contentWidth);
    this.setTruncatedText(charsLimit);
  }

  private onMediaQueryChange(event: MediaQueryListEvent): void {
    // Check if either of the resolutions matches when the screen size changes
    this.checkResolution();
  }

  private setContentWidth(contentWidth: string): void {
    if (this.elementRef.nativeElement) {
      // update the max width for the note
      const textElement = (this.elementRef.nativeElement as HTMLElement).parentElement;
      textElement ? textElement.style.maxWidth = contentWidth : null;
    }
  }

  public setTruncatedText(charsLimit: number) {
    const completeText = this.langService.langMap[this._config.translationKey];
    const elementRef = this.elementRef.nativeElement as HTMLElement;
    elementRef.innerHTML = `${completeText.slice(0, charsLimit)}...`;
  }

  ngOnDestroy(): void {
    Object.entries(this._config.mediaQueryCharsMapping).forEach(([key, data]) => {
      data.mediaQuery.removeEventListener('change', this.onMediaQueryChange.bind(this));
    });

    this.subscription.unsubscribe();
  }
}
